export const actionTypes = {
  GET_ALL_REGIONS: 'GET_ALL_REGIONS',
  GET_ALL_COUNTRIES: 'GET_ALL_COUNTRIES',
  GET_ALL_REGIONS_SUCCESS: 'GET_ALL_REGIONS_SUCCESS',
  GET_ALL_COUNTRIES_SUCCESS: 'GET_ALL_COUNTRIES_SUCCESS',
  GET_COUNTRIES: 'GET_COUNTRIES',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_COUNTRY: 'GET_COUNTRY',
  GET_COUNTRY_SUCCESS: 'GET_COUNTRY_SUCCESS',
  CREATE_COUNTRY: 'CREATE_COUNTRY',
  UPDATE_COUNTRY: 'UPDATE_COUNTRY',
  UPDATE_COUNTRY_SUCCESS: 'UPDATE_COUNTRY_SUCCESS',
};

export const getAllRegions = () => ({
  type: actionTypes.GET_ALL_REGIONS,
});

export const getAllRegionsSuccess = data => ({
  type: actionTypes.GET_ALL_REGIONS_SUCCESS,
  payload: data,
});

export const getAllCountries = () => ({
  type: actionTypes.GET_ALL_COUNTRIES,
});

export const getAllCountriesSuccess = data => ({
  type: actionTypes.GET_ALL_COUNTRIES_SUCCESS,
  payload: data,
});

export const getCountries = (
  data,
  callback = (_res: { message: string; countries: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.GET_COUNTRIES,
  payload: data,
  callback,
});

export const getCountriesSuccess = data => ({
  type: actionTypes.GET_COUNTRIES_SUCCESS,
  payload: data,
});

export const getCountry = (id: string, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_COUNTRY,
  callback,
  payload: id,
});

export const getCountrySuccess = data => ({
  type: actionTypes.GET_COUNTRY_SUCCESS,
  payload: data,
});

export const createCountry = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_COUNTRY,
  payload: data,
  callback,
});

export const updateCountry = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.UPDATE_COUNTRY,
  payload: data,
  callback,
});

export const updateCountrySuccess = data => ({
  type: actionTypes.UPDATE_COUNTRY_SUCCESS,
  payload: data,
});
